export default "__VITE_ASSET__BUXEQwjg__"